// Referências externas
import { FiX } from 'react-icons/fi';

export default function (props) {
    return (
        <div className="modal-fundo">
            <div className="modal-form-confirmar-exclusao-medida">
                <div className="modal-conteudo-confirmar-exclusao-medida">
                    <div className="modal-header">
                        <h4 className="wrapper-titulo">Confirmar Exclusão</h4>
                        <button className="botao-fechar-modal" onClick={() => props.fecharModal()} >
                            <FiX />
                        </button>
                    </div>
                    <span>Ao reduzir o número de medidas será perdida a informação inserida na última medida da lista. Deseja prosseguir:</span>

                    <div className="botoes-modal-form-confirmar-exclusao-medida">
                        <button className="button-cancel" onClick={() => props.fecharModal()}> Cancelar ação </button>
                        <div className="modal-form-dados-acidente-espaco"></div>
                        <button className="button-submit" onClick={() => props.confirmarRemocaoMedida()}> Sim, apagar medida </button>
                    </div>
                </div>
            </div>
        </div>
    );
}